import * as React from "react";
import {Dropdown, Table, Button as SementicButton} from "semantic-ui-react";
import {formatDate, SYSTEM_USER} from "../Table/dataHandler/Utils";
import Button from "../Button";
import Dialog from "./Dialog";
import {CategoryTextDto, HistoryDto, ModeltypeBasicDto} from "../../services/Client";
import {IUserSettings} from "src/data/IUserSettings";
import ReactQuill from "react-quill";
import {plainTextToQuillHtml} from "../Table/components/twoLanguage/EditorUtil";

interface IHistoryDialogProps {
    identifier: string | undefined;
    historyData: HistoryDto[];
    t: reactI18Next.TranslationFunction;
    onClose: () => void;
    categories?: CategoryTextDto[];
    dialogTitle: string;
    filterValues?: Set<string>;
    onChangeFilterValue?: (fieldKey: string | undefined) => void;
    userSettings?: IUserSettings;
    derivates?: Array<ModeltypeBasicDto>;
    onShowMoreHistory?: (id: string) => void;
    onCloseMoreHistotyDialog?: () => void;
    moreHistoryData?: HistoryDto[];
    isShowMoreHistory?: boolean;
}

export const HistoryDialog = (props: IHistoryDialogProps) => {
    const filterOptions = props.filterValues && Array.from(props.filterValues).map((value: string, index: number) => (
        {
            key: index,
            text: props.t("HISTORY:" + value),
            value: value
        }
    ));
    const modifiedLabelAsPerCurrentLanguage = (assignedModeltypes: any[]) => {
        if (props.userSettings && props.derivates) {
            const currentLanguage = props.userSettings.language;
            const allDerivates: Array<any> = [];
            props.derivates.map(derivates => {
                if (derivates.names) {
                    derivates.names.map(derivate => {
                        if (derivate.language.code) {
                            derivate.language.code = derivate.language.code.trim();
                        }
                        if (derivate.name) {
                            derivate.name = derivate.name.trim();
                        }
                        allDerivates.push({...derivate, parentId: derivates.objectId});
                    });
                }
            });

            const newassignedModeltypes = assignedModeltypes.map(seperateValue => {
                let newValue = seperateValue;
                if (props.derivates) {
                    const splitLabel = seperateValue.split('-');
                    const getSpecificNewValue = allDerivates.find(p => p.name === splitLabel[0].trim());
                    if (getSpecificNewValue) {
                        const getLanguageSpecificNewValue = props.derivates.filter(p => p.objectId === getSpecificNewValue.parentId).map(p => p.names);
                        if (getLanguageSpecificNewValue && getLanguageSpecificNewValue[0]) {
                            const getFirstEle = getLanguageSpecificNewValue[0];
                            if (getFirstEle) {
                                const getCurrentLanguageNewValue = getFirstEle.find((p: any) => p.language.code === currentLanguage);
                                if (getCurrentLanguageNewValue && getCurrentLanguageNewValue.name) {
                                    newValue = getCurrentLanguageNewValue.name + '-' + splitLabel[1];
                                }
                            }
                        }
                    }
                }
                return newValue;
            });
            return newassignedModeltypes;
        }
        return assignedModeltypes;
    };
    let renderAssignments = (previousValue: string, newValue: string) => {
        let deletedDerivtes: any[] = [];
        let addedDerivtes: any[] = [];

        let previousAssignedModeltypes: any[] = previousValue.split(',').map(value => value.trim());
        let assignedModeltypes: any[] = newValue.split(',').map(value => value.trim());

        assignedModeltypes = modifiedLabelAsPerCurrentLanguage(assignedModeltypes);
        previousAssignedModeltypes = modifiedLabelAsPerCurrentLanguage(previousAssignedModeltypes);

        if (previousAssignedModeltypes && assignedModeltypes) {
            deletedDerivtes = previousAssignedModeltypes.filter(x => !assignedModeltypes.includes(x)); // deleted derivates
            addedDerivtes = assignedModeltypes.filter(x => !previousAssignedModeltypes.includes(x)); // added derivates
        }

        let newDerivates = assignedModeltypes.map(amtb => {
            return (amtb &&
                (
                    <div key={amtb.objectId} style={{fontWeight: addedDerivtes.includes(amtb) ? 'bold' : 'normal'}}>
                        {amtb}
                    </div>
                )
            );
        });

        let deleted = deletedDerivtes.map(amtb => {
            return (amtb &&
                (
                    <div key={amtb.objectId} style={{textDecoration: 'line-through'}}>
                        {amtb}
                    </div>
                )
            );
        });

        return newDerivates.concat(deleted);
    };

    const onShowMore = (item: HistoryDto, key: string) => {
        const field = item[key];
        if (field && props.onShowMoreHistory) {
            const id = field.substring(0, field.indexOf('-'));
            props.onShowMoreHistory(id || '');
        }
    };

    const renderPreviousAssignments = (previousValue: string) => {
        let assignedModeltypes: any[] = previousValue.split(',').map(value => value.trim());
        assignedModeltypes = modifiedLabelAsPerCurrentLanguage(assignedModeltypes);
        return assignedModeltypes.map(value => (
            <div>{value.trim()}</div>
        ));
    };
    let renderValue = (item: HistoryDto): JSX.Element => {
        if (item.fieldKey === 'LONGTEXT_EN' || item.fieldKey === 'LONGTEXT_DE'
            || item.fieldKey === 'USP_DE' || item.fieldKey === 'USP_EN'
            || item.fieldKey === 'FOOTER_DE' || item.fieldKey === 'FOOTER_EN') {
            return (
                <Table.Cell style={{whiteSpace: 'pre-wrap', verticalAlign: 'top'}}>
                    <ReactQuill
                        className="no-border-quill"
                        modules={{toolbar: false}} // Hide toolbar
                        readOnly={true} // Make ReactQuill read-only
                        value={!/^<.*?>.*<\/.*?>$/.test(item.newValue || '')
                            ? plainTextToQuillHtml(item.newValue || '')
                            : item.newValue || ""}
                    />
                </Table.Cell>
            );
        }
        return (
            <Table.Cell style={{whiteSpace: 'pre-wrap', verticalAlign: 'top'}}>
                <>
                    {item.fieldKey === "CATEGORY" && props.categories && props.categories.filter(a => a.categoryCode === item.newValue)[0] != null ?
                        props.categories.filter(a => a.categoryCode === item.newValue)[0].text
                        : item.fieldKey === "ASSIGNMENT" ? item.newValue && renderAssignments(item.previousValue || '', item.newValue || '')
                            : (item.newValue && item.fieldKey === 'WORKFLOW') ? item.newValue.substring(item.newValue.indexOf('-') + 1)
                                : item.fieldKey === "SHOW_HIDE" ? item.newValue === 'true' ? props.t("HISTORY:SHOW") : props.t("HISTORY:HIDE") : item.newValue}
                    <br />
                    {(item.fieldKey === 'WORKFLOW' && item.newValue) &&
                        <SementicButton className="link-button" onClick={() => onShowMore(item, 'newValue')}>Show More History</SementicButton>}
                </>

            </Table.Cell>
        );
    };

    const renderPreviousValue = (item: HistoryDto): JSX.Element => {
        if (item.fieldKey === 'LONGTEXT_EN' || item.fieldKey === 'LONGTEXT_DE'
            || item.fieldKey === 'USP_DE' || item.fieldKey === 'USP_EN'
            || item.fieldKey === 'FOOTER_DE' || item.fieldKey === 'FOOTER_EN') {
            return (
                <Table.Cell style={{color: item.newlyCreatedFlag ? 'red' : 'black', whiteSpace: 'pre-wrap', verticalAlign: 'top'}}>
                    <ReactQuill
                        className="no-border-quill"
                        modules={{toolbar: false}} // Hide toolbar
                        readOnly={true} // Make ReactQuill read-only
                        value={item.previousValue || ''}
                    />
                </Table.Cell>
            );
        }
        return (
            <Table.Cell style={{color: item.newlyCreatedFlag ? 'red' : 'black', whiteSpace: 'pre-wrap', verticalAlign: 'top'}}>
                <>
                    {item.newlyCreatedFlag ? props.t("HISTORY:NEW_ENTRY") :
                        item.fieldKey === "CATEGORY" && props.categories && props.categories.filter(a => a.categoryCode === item.previousValue)[0] != null ?
                            props.categories.filter(a => a.categoryCode === item.previousValue)[0].text
                            : item.fieldKey === "ASSIGNMENT" ? item.previousValue && renderPreviousAssignments(item.previousValue)
                                : (item.previousValue && item.fieldKey === 'WORKFLOW') ? item.previousValue.substring(item.previousValue.indexOf('-') + 1)
                                    : item.fieldKey === "SHOW_HIDE" ? item.previousValue === 'true' ? props.t("HISTORY:SHOW") : props.t("HISTORY:HIDE") : item.previousValue}
                    <br />
                    {(item.fieldKey === 'WORKFLOW' && item.previousValue) &&
                        <SementicButton className="link-button" onClick={() => onShowMore(item, 'previousValue')}>Show More History</SementicButton>}
                </>

            </Table.Cell>
        );
    };
    return (
        <>
            <Dialog
                title={props.t("HISTORY:" + props.dialogTitle, {identifier: props.identifier})}
                open={true}
                fullWidth={true}
                actions={[
                    <Button
                        key={"closeButton"}
                        icon={"ban"}
                        onClick={props.onClose}
                    />
                ]}
            >
                {props.historyData.length === 0 ? props.t("HISTORY:NO_HISTORY_AVAILABLE") :
                    <Table
                        celled={true}
                        structured={true}
                    >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>{props.t("HISTORY:CHANGED_TIMESTAMP")}
                                    <div />
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                    {props.t("HISTORY:FIELD_KEY")}
                                    {props.filterValues &&
                                        <Dropdown
                                            style={{width: "200px"}}
                                            fluid={true}
                                            selection={true}
                                            clearable={true}
                                            options={filterOptions}
                                            onChange={(e, v) => props.onChangeFilterValue && props.onChangeFilterValue(v.value as string)}
                                        />
                                    }
                                </Table.HeaderCell>
                                <Table.HeaderCell>{props.t("HISTORY:PREVIOUS_VALUE")}</Table.HeaderCell>
                                <Table.HeaderCell>{props.t("HISTORY:NEW_VALUE")}</Table.HeaderCell>
                                <Table.HeaderCell>{props.t("HISTORY:CHANGED_BY")}</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>
                            {props.historyData.map((item, index) =>
                                <Table.Row key={'key-' + index}>
                                    <Table.Cell>{formatDate(item.changedTimestamp)}</Table.Cell>
                                    <Table.Cell>{props.t("HISTORY:" + item.fieldKey)}</Table.Cell>
                                    {renderPreviousValue(item)}
                                    {renderValue(item)}
                                    <Table.Cell>{item.changedBy === SYSTEM_USER ? props.t("GLOBAL:SYSTEM_USER") : item.changedBy}</Table.Cell>
                                </Table.Row>
                            )}
                        </Table.Body>
                    </Table>
                }
            </Dialog>
            <Dialog
                title={props.t("HISTORY:" + props.dialogTitle, {identifier: props.identifier})}
                open={props.isShowMoreHistory || false}
                fullWidth={false}
                actions={[
                    <Button
                        key={"closeButton"}
                        icon={"ban"}
                        onClick={props.onCloseMoreHistotyDialog}
                    />
                ]}
            >
                {props.moreHistoryData && props.moreHistoryData.length === 0 ? props.t("HISTORY:NO_HISTORY_AVAILABLE") :
                    <Table
                        celled={true}
                        structured={true}
                    >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>{props.t("HISTORY:CHANGED_TIMESTAMP")}
                                    <div />
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                    {props.t("HISTORY:FIELD_KEY")}
                                    {/* {props.filterValues &&
                                        <Dropdown
                                            style={{width: "200px"}}
                                            fluid={true}
                                            selection={true}
                                            clearable={true}
                                            options={filterOptions}
                                            onChange={(e, v) => props.onChangeFilterValue && props.onChangeFilterValue(v.value as string)}
                                        />
                                    } */}
                                </Table.HeaderCell>
                                <Table.HeaderCell>{props.t("HISTORY:PREVIOUS_VALUE")}</Table.HeaderCell>
                                <Table.HeaderCell>{props.t("HISTORY:NEW_VALUE")}</Table.HeaderCell>
                                <Table.HeaderCell>{props.t("HISTORY:CHANGED_BY")}</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>
                            {props.moreHistoryData && props.moreHistoryData.map((item, index) =>
                                <Table.Row key={'key-' + index}>
                                    <Table.Cell>{formatDate(item.changedTimestamp)}</Table.Cell>
                                    <Table.Cell>{props.t("HISTORY:" + item.fieldKey)}</Table.Cell>
                                    {renderPreviousValue(item)}
                                    {renderValue(item)}
                                    <Table.Cell>{item.changedBy === SYSTEM_USER ? props.t("GLOBAL:SYSTEM_USER") : item.changedBy}</Table.Cell>
                                </Table.Row>
                            )}
                        </Table.Body>
                    </Table>
                }
            </Dialog>

        </>

    );
};



// WEBPACK FOOTER //
// ./src/components/Dialogs/HistoryDialog.tsx